<template>
    <div class="tech">
        <div class="banner">
            <img src="../assets/zy/tbanner.png" alt="">
        </div>
        <div class="main">
           <div class="one">
                <div class="left wow fadeInLeft">
                  <p class="title">{{$t('tech').text0}}</p>
                    <p class="intro">{{$t('tech').text1}}</p>
                    <div class="threeNum" ref="counts" :class="{'enThree':$i18n.locale=='en'}">
                        <div class="item">
                            <div class="num">
                                <span id="num1">130</span>
                                <span>+</span>
                            </div>
                            <p>{{$t('tech').text2}}</p>
                        </div>
                        <div class="item">
                            <div class="num">
                                <span id="num2">200</span>
                                <span>+</span>
                            </div>
                            <p>{{$t('tech').text3}}</p>
                        </div>
                        <div class="item">
                            <div class="num">
                                <span id="num3">16</span>
                                <span>+</span>
                            </div>
                            <p>{{$t('tech').text4}}</p>
                        </div>
                    </div>
                </div>
               <div class="right wow zoomIn">
                   <img src="../assets/zy/hr.png" alt="">
               </div>
           </div>
            <div class="two wow zoomIn">
                <img src="../assets/zy/join.png" alt="">
                <div class="jList">
                   <p class="title">{{$t('tech').text5}}</p>
                    <aboutDia />
                </div>
            </div>
        </div>
        <foot-Component class="wow fadeIn"></foot-Component>
    </div>
</template>

<script>
    import { CountUp } from 'countup.js'
    import footComponent from '../components/foot'
    import aboutDia from '../components/aboutDia'
    import Scrollbar from 'smooth-scrollbar'
    import { getProductsUrl} from '../util/lang'
    export default {
        name: 'about',
        data(){
            return{
            }
        },
        components:{footComponent,aboutDia},
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            this.scrollbar.addListener((status) => {
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.$nextTick(()=>{
                this.count()
            })

        },
        methods:{
            count(){
                let element=this.$refs.counts;
                let actualTop = element.offsetTop;
                let current = element.offsetParent;
                while (element=element.offsetParent){
                    actualTop += element.offsetTop;
                    /* current = current.offsetParent; */
                }
                let demoFi1 = new CountUp("num1", 30);
                let demoFi2 = new CountUp("num2", 2000);
                let demoFi3 = new CountUp("num3", 16);
                // demoFi1.start();
                // demoFi2.start();
                // demoFi3.start();
                let numok=false;
                let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                if(scrollbar){
                    scrollbar.addListener((status) => {
                        if(!numok){
                            if(actualTop<status.offset.y+document.body.clientHeight){
                                demoFi1.start();
                                demoFi2.start();
                                demoFi3.start();
                                numok=true;
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tech{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
        }
        .main{
            width:100%;
            margin: 60px auto;
            .one{
                width:1440px;
                margin: 0 auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .left{
                   width:50%;
                    .title{
                        width:100%;
                        font-size: 26px;
                        color:#333333;
                        font-family: "SourceHanSansSC-Regular";
                        display: flex;
                        flex-direction: column;
                        &::after{
                            content:'';
                            display: inline-block;
                            height:5px;
                            width:47px;
                            background-color: #FDCC49;
                            margin-top: 20px;
                        }
                    }
                    .intro{
                        color:#333333;
                        margin: 30px 0;
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        line-height: 25px;
                        font-size: 14px;
                        width:80%;
                    }
                    .threeNum{
                        width:80%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        .item{
                            .num{
                                position: relative;
                                span:nth-child(1){
                                    font-size: 40px;
                                    font-family: "os";
                                    display: inline-block;
                                    width:100%;
                                    text-align: center;
                                }
                                span:nth-child(2){
                                    position: absolute;
                                    right:-20px;
                                    top:0;
                                    font-family: "DINEngschriftStd";
                                    font-size: 25px;
                                    color:#333333;
                                    text-transform: uppercase;

                                }
                            }
                            p{
                                color:#333333;
                                font-family: "AdobeHeitiStd-Regular";
                                text-align: center;
                            }
                        }
                        .item:last-child{
                            .num {
                                span:nth-child(2){
                                    right:0px;
                                }
                            }
                        }
                    }
                }
                .right{
                    width:45%;
                    cursor: pointer;
                    overflow: hidden;
                    img{
                        width:100%;
                        display: block;
                        object-fit: cover;
                        transition: all 600ms;
                    }
                    &:hover{
                        img{
                            transform: scale(1.2);
                        }
                    }
                }
            }
            .two{
                width:100%;
               margin-top: 80px;
                position: relative;
                img{
                    width:100%;
                    display: block;
                    object-fit: cover;
                }
                .jList{
                    width:80%;
                    position: absolute;
                    left:10%;
                    top:80px;
                    .title{
                        width:100%;
                        font-size: 26px;
                        color:white;
                        font-family: "SourceHanSansSC-Regular";
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        &::after{
                            content:'';
                            display: inline-block;
                            height:5px;
                            width:47px;
                            background-color: #FDCC49;
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
        .foot{
            animation-name: polygon;
            animation-duration: 2s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(100% 0, 99% 50%, 50% 99%,100% 50%);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1440px){
            .main{
                width:100%;
                .one{
                    width:90%;
                }
                .two{
                    img{
                        height:800px;
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
            }
          .main{
              .one{
                 flex-direction: column;
                  .left,.right{
                      width:100%;
                  }
                  .left{
                      .threeNum{
                          width:100%;
                          .item{
                              .num{
                                  span:nth-child(2){

                                  }
                              }
                          }
                      }
                      .enThree{
                       .item{
                           .num{
                               span:nth-child(2){
                                   right:10px;
                               }
                           }
                       }
                          .item:nth-child(2){
                              .num{
                                  span:nth-child(2){
                                      right:-15px;
                                  }
                              }
                          }
                      }
                      .intro{
                          width:100%;
                      }
                  }
                  .right{
                      margin-top: 30px;
                  }
              }
              .two{
                  margin-top: 30px;
                  img{
                      height:1000px;
                  }
                  .jList{
                      width:100%;
                      left:0;
                  }
              }
          }
        }
    }
</style>
